export default "__VITE_ASSET__4PBZt4BX__"